'use client'

import { LanguageProvider } from './language'

export default function InfoLayout({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  return <LanguageProvider>{children}</LanguageProvider>
}
